import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IResponse } from '@umu/umu-types';

export interface IOutput {
    download_status: number;
    download_url: string;
    file_name: string;
    file_type: string;
}

interface IInput {
    homework_id: number;
}


export const downloadHomework = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.HOMEWORK_DOWNLOAD, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
